<template>
  <svg :width="width" :height="height" viewBox="0 0 11 11" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.29 10.485C2.9 10.485 1.835 10.05 1.095 9.18C0.365 8.31 0 7.125 0 5.625V3.165H1.035V5.625C1.035 6.865 1.31 7.81 1.86 8.46C2.41 9.11 3.22 9.435 4.29 9.435C5.36 9.435 6.17 9.11 6.72 8.46C7.27 7.81 7.545 6.865 7.545 5.625V2.205H8.58V5.625C8.58 7.125 8.21 8.31 7.47 9.18C6.74 10.05 5.68 10.485 4.29 10.485ZM5.655 3.165L8.07 0L10.485 3.165H5.655Z" fill="#006EFF"/>
  </svg>
</template>

<script>import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.backgroundBlueButton }
  },
  name: "IconAnswerMessage"
}
</script>